/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AssignAuthSupportRequestBody } from '../../models/assign-auth-support-request-body';

export interface AssignAuthSupportsToSubscription$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
      body: AssignAuthSupportRequestBody
}

export function assignAuthSupportsToSubscription(http: HttpClient, rootUrl: string, params: AssignAuthSupportsToSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, assignAuthSupportsToSubscription.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

assignAuthSupportsToSubscription.PATH = '/subscriptions/{uid}/auth-supports/assign';
